import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@geely/ui";
import { Pencil, Trash2 } from 'lucide-react';
import type { Store } from '@geely/shared';

interface StoresTableProps {
  stores: Store[];
  onEdit: (store: Store) => void;
  onDelete: (id: string) => void;
}

export function StoresTable({ stores, onEdit, onDelete }: StoresTableProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Lojas Cadastradas</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nome</TableHead>
                <TableHead>Dealer</TableHead>
                <TableHead>UF</TableHead>
                <TableHead>Cidade</TableHead>
                <TableHead>Telefone</TableHead>
                <TableHead>Email</TableHead>
                <TableHead className="text-center">Atend. Paralelos</TableHead>
                <TableHead className="text-right">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {stores.map((store) => (
                <TableRow key={store.id}>
                  <TableCell className="font-medium">{store.name}</TableCell>
                  <TableCell>{store.dealerName}</TableCell>
                  <TableCell>{store.state}</TableCell>
                  <TableCell>{store.city}</TableCell>
                  <TableCell>{store.phone}</TableCell>
                  <TableCell>{store.email}</TableCell>
                  <TableCell className="text-center">{store.parallelAppointments}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onEdit(store)}
                      >
                        <Pencil className="size-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onDelete(store.id)}
                      >
                        <Trash2 className="size-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
